import { useQuery } from "@tanstack/react-query";
import { EntityMembershipPolicies } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const MEMBERSHIP_POLICIES_QUERY_KEY = "membership-policies";
export const keyFn = (entityId, entityType) => [MEMBERSHIP_POLICIES_QUERY_KEY, entityType, entityId];
export const fetchMembershipPolicies = async (entityId, entityType) => EntityMembershipPolicies.getByInitiatorId(entityType, entityId);
const useEntityMembershiPolicies = (entityId, entityType, { enabled } = { enabled: true }) => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: keyFn(entityId, entityType),
    queryFn: () => defaultOnError(
      fetchMembershipPolicies(entityId, entityType),
      "Loading Membership policies for entity failed with status",
      "Could not load Membership policies for entity"
    ),
    enabled
  });
  return {
    data: data != null ? data : null,
    isLoading: isFetching,
    refetch
  };
};
export default useEntityMembershiPolicies;
